import React, { Component } from 'react';
import './App.css';
import './Style.css';
import '../src/assets/css/tailwind.css';
import { AppHoc } from './utils/hocs';
import MainLayout from './components/MainLayout';
import {LoginPage, ForgotPasswordPage, ResetPasswordPage, MFAConfirmationPage, QRCodePage, MFAMethodPage, OTPPage, BackupCodesPage, SamlLoginPage} from './components/Login';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import Dashboard from './components/analytics/Dashboard';
import Utilization from './components/analytics/Utilization';
import Events from './components/calendar/Events';
import TestResults from './components/analytics/TestResults';
import HealthRisks from './components/analytics/HealthRisks';
import Challenges from './components/leaderboard/Challenges';
import Steps from './components/leaderboard/Steps';
import PreEmpCheckup from './components/preEmployeeCheckup/PreEmpCheckup';
import CalendarComp from './components/calendar/Calendar';
import CreateCalendarEvent from './components/calendar/CreateCalendarEvent';
import EditCalendarEvent from './components/calendar/EditCalendarEvent';
import PreRegistration from './components/Others/PreRegistration';
import CustomerAppointments from './components/Others/CustomerAppointments';
import Facilities from './components/Others/Facilities';
import AccountManagers from './components/Help/AccountManagers';
import HealthCoach from './components/analytics/HealthCoach';
import HealthChecks from './components/analytics/HealthChecks';
import CompanyDemographics from './components/analytics/CompanyDemographics';
import CompanyWellnessScore from './components/analytics/CompanyWellnessScore';
import DoctorConsultations from './components/analytics/DoctorConsultations';
import HealthCheckTrends from './components/analytics/HealthCheckTrends';
import GymTrends from './components/gym/Trends';
import fetchIntercept from 'fetch-intercept';
import {EmployeeRegistrationPage, FamilyRegistrationPage, DeleteEmployeesPage, ManageEmployeesPage, UpdateEmployeesPage, ManageEmployeeForm, UpdateEmployeeForm, FileUpload, ViewErrors, ViewResult, AddEmployee} from './components/employeeData';
import DoctorConsultationPage from './components/utilization/DoctorConsultation';
import {HealthCoachPage, HRAPage, GymAndFitnessPage, PharmacyPage, VaccinationPage, ActivityLog, SpendingAccountLayout} from './components/utilization';
import * as Pages from './pages'
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import MailLandingPage from './components/mailSetup/MailLandingPage';
import MailSetup from './components/mailSetup/MailSetup';
import MailConfig from './components/mailSetup/MailConfig';
import misPage from './components/mis/misPage';
import AddMisPulse from './components/mis/AddMisPulse';
import { StepathonPage, CreateStepathonPage, UpdateStepathonPage, Leaderboard, TeamListPage, TeamUpload, MemberUpload, MemberListPage  } from './components/Engagement/index';
import BulkUploadCard from './components/preEmployeeCheckup/BulkUploadCard';
import ViewPage from "./components/utilization/ViewPage"
import MentalWellness from './components/analytics/MentalWellness';
import EmployeeDetailsCard from './components/preEmployeeCheckup/EmployeeDetailsCard';
import DynamicBenefitPage from './components/utilization/DynamicBenefitPage';
import PpmcEmpCheckup from './components/ppmcEmployeeCheckup/PpmcEmpCheckup';
import BulkUploadCardPpmc from './components/ppmcEmployeeCheckup/BulkUploadCard';
var isLoggedIn = JSON.parse(sessionStorage.getItem('isLoggedIn'))
  ? JSON.parse(sessionStorage.getItem('isLoggedIn'))
  : false;
var isRegionalStaff = sessionStorage.getItem('role') === 'regional_staff';

const PrivateRoute = ({ component: Component, child: Child, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isLoggedIn ? (
        <AppHoc>
          <Component {...props} child={Child} />
        </AppHoc>
      ) : (
        <Redirect to='/login' />
      )
    }
  />
);

fetchIntercept.register({
  response: function (response) {
    if (response.status === 401) {
      window.location.href = '/login';
    }
    return response;
  },
});

window.axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (401 === error.response.status) {
      window.location = '/login';
    } else {
      return Promise.reject(error);
    }
  }
);

window.onload = () => {
  if(window.location.host == 'www.ekincare.com') {
    Sentry.init({
      dsn: 'https://070032f8b757484a8e13faf67508d53e@sentry.io/1421538',
      integrations: [new Integrations.BrowserTracing()],
      tracesSampleRate: 1.0,
    })
  }
}
class App extends Component {
  constructor(props) {
    super(props);
    this.getLoginStatus = this.getLoginStatus.bind(this);
  }

  getLoginStatus(status) {
    isLoggedIn = status;
    sessionStorage.setItem('isLoggedIn', isLoggedIn);
  }

  render() {
    return (
      <BrowserRouter basename='/'>
        
        <Switch>
          <Route
            exact
            path='/login'
            render={(props) => (
              <LoginPage {...props} getLoginStatus={this.getLoginStatus} />
            )}
          />
          <Route
            exact
            path='/saml-login'
            render={(props) => (
              <SamlLoginPage {...props} getLoginStatus={this.getLoginStatus} />
            )}
          />
          <Route
            exact
            path='/forgot-password'
            render={(props) => (
              <ForgotPasswordPage {...props} getLoginStatus={this.getLoginStatus} />
            )}
          />
          <Route
            exact
            path='/reset-password/:token'
            render={(props) => (
              <ResetPasswordPage {...props} getLoginStatus={this.getLoginStatus} />
            )}
          />
          <Route
            exact
            path='/mfa-confirmation'
            render={(props) => (
              <MFAConfirmationPage {...props} getLoginStatus={this.getLoginStatus} />
            )}
          />
          <Route
            exact
            path='/mfa-qr'
            render={(props) => (
              <QRCodePage {...props} getLoginStatus={this.getLoginStatus} />
            )}
          />
           <Route
            exact
            path='/mfa-method'
            render={(props) => (
              <MFAMethodPage {...props} getLoginStatus={this.getLoginStatus} />
            )}
          />
          <Route
            exact
            path='/mfa-otp'
            render={(props) => (
              <OTPPage {...props} getLoginStatus={this.getLoginStatus} />
            )}
          />
          <Route
            exact
            path='/mfa-backup-code'
            render={(props) => (
              <BackupCodesPage {...props} getLoginStatus={this.getLoginStatus} />
            )}
          />
          <PrivateRoute
            exact
            path='/'
            component={MainLayout}
            child={Pages.Overview}
          />
          <PrivateRoute
            exact
            path='/forbidden'
            component={MainLayout}
            child={Pages.Forbidden}
          />
          <PrivateRoute
            exact
            path='/dashboard'
            component={MainLayout}
            child={Dashboard}
          />
          <PrivateRoute
            exact
            path='/utilization'
            component={MainLayout}
            child={Utilization}
          />
          <PrivateRoute
            exact
            path='/wellness-calendar/events'
            component={MainLayout}
            child={Events}
          />
          <PrivateRoute
            exact
            path='/wellness-calendar/event/:id/edit'
            component={MainLayout}
            child={EditCalendarEvent}
          />
          <PrivateRoute
            exact
            path='/test-results'
            component={MainLayout}
            child={TestResults}
          />
          <PrivateRoute
            exact
            path='/mental-wellness'
            component={MainLayout}
            child={MentalWellness}
          />

          <PrivateRoute
            exact
            path='/health-risks'
            component={MainLayout}
            child={HealthRisks}
          />
          {/* <PrivateRoute
            exact
            path='/health-coach'
            component={MainLayout}
            child={HealthCoach}
          /> */}
          <PrivateRoute
            exact
            path='/spending-account'
            component={MainLayout}
            child={SpendingAccountLayout}
          />
          <PrivateRoute
            exact
            path='/health-check'
            component={MainLayout}
            child={HealthChecks}
          />
          
          <PrivateRoute
            exact
            path="/utilization/:benefitType"
            component={MainLayout}
            child={DynamicBenefitPage}
          />
    
          <PrivateRoute
            exact
            path='/health-check-trends'
            component={MainLayout}
            child={HealthCheckTrends}
          />
          <PrivateRoute
            exact
            path='/demographics'
            component={MainLayout}
            child={CompanyDemographics}
          />
          <PrivateRoute
            exact
            path='/wellness-score'
            component={MainLayout}
            child={CompanyWellnessScore}
          />
          {/* <PrivateRoute
            exact
            path='/doctor-consultations'
            component={MainLayout}
            child={DoctorConsultations}
          /> */}
          <PrivateRoute
            exact
            path='/health-risk-assessment'
            component={MainLayout}
            child={HRAPage}
          />
          <PrivateRoute
            exact
            path='/vaccination'
            component={MainLayout}
            child={VaccinationPage}
          />
           <PrivateRoute
            exact
            path='/back-to-office'
            component={MainLayout}
            child={VaccinationPage}
          />
          <PrivateRoute
            exact
            path='/challenges'
            component={MainLayout}
            child={Challenges}
          />
          <PrivateRoute
            exact
            path='/steps'
            component={MainLayout}
            child={Steps}
          />
          <PrivateRoute
            exact
            path='/pre-employee-checkup'
            component={MainLayout}
            child={PreEmpCheckup}
          />
          <PrivateRoute
            exact
            path='/ppmc-employee-checkup'
            component={MainLayout}
            child={PpmcEmpCheckup}
          />
                <PrivateRoute
            exact
            path='/ppmc-employee-checkup/bulk-upload'
            component={BulkUploadCardPpmc}
          />
          <PrivateRoute
          exact
          path='/pre-employee-checkup/employee-card'
          component={EmployeeDetailsCard}
          />
          <PrivateRoute
            exact
            path='/pre-employee-checkup/bulk-upload'
            component={BulkUploadCard}
          />
          <PrivateRoute
            exact
            path='/stepathon'
            component={MainLayout}
            child={StepathonPage}
          />
          <PrivateRoute
            exact
            path='/stepathon/create-stepathon'
            component={MainLayout}
            child={CreateStepathonPage}
          />
          <PrivateRoute
            exact
            path='/stepathon/team-upload'
            component={TeamUpload}
          />
          <PrivateRoute
            exact
            path='/stepathon/member-upload'
            component={MemberUpload}
          />
          <PrivateRoute
            exact
            path='/stepathon/update-stepathon'
            component={MainLayout}
            child={UpdateStepathonPage}
          />
          <PrivateRoute
            exact
            path='/stepathon/view-teams'
            component={MainLayout}
            child={TeamListPage}
          />
          <PrivateRoute
            exact
            path='/stepathon/view-members'
            component={MainLayout}
            child={MemberListPage}
          />
           <PrivateRoute
            exact
            path='/stepathon/leader-board'
            component={Leaderboard}
          />
          <PrivateRoute
            exact
            path='/wellness-calendar'
            component={MainLayout}
            child={CalendarComp}
          />
          <PrivateRoute
            exact
            path='/wellness-calendar/create-event'
            component={MainLayout}
            child={CreateCalendarEvent}
          />
          <PrivateRoute
            exact
            path='/overview'
            component={MainLayout}
            child={Pages.Overview}
          />
          <PrivateRoute
            exact
            path='/pre-registration'
            component={MainLayout}
            child={PreRegistration}
          />
          <PrivateRoute
            exact
            path='/customer-appointments'
            component={MainLayout}
            child={CustomerAppointments}
          />
          <PrivateRoute
            exact
            path='/facilities'
            component={MainLayout}
            child={Facilities}
          />
          <PrivateRoute
            exact
            path='/account-managers'
            component={MainLayout}
            child={AccountManagers}
          />
          {/* <PrivateRoute
            exact
            path='/gym-trends'
            component={MainLayout}
            child={GymTrends}
          /> */}
          <PrivateRoute
            exact
            path='/employee-registration'
            component={MainLayout}
            child={EmployeeRegistrationPage}
          />
          <PrivateRoute
            exact
            path='/deactivate-employees'
            component={MainLayout}
            child={DeleteEmployeesPage}
          />
          <PrivateRoute
            exact
            path='/update-employees'
            component={MainLayout}
            child={UpdateEmployeesPage}
          />
            <PrivateRoute
            exact
            path='/manage-employee'
            component={MainLayout}
            child={ManageEmployeesPage}
          />
          <PrivateRoute
            exact
            path='/manage-employee/add-employee'
            component={AddEmployee}
          />
          <PrivateRoute
            exact
            path='/manage-employee/edit'
            component={ManageEmployeeForm}
          />
          <PrivateRoute
            exact
            path='/update-employees/edit'
            component={UpdateEmployeeForm}
          />
          <PrivateRoute
            exact
            path='/family-registration'
            component={MainLayout}
            child={FamilyRegistrationPage}
          />
          <PrivateRoute
            exact
            path='/employee-data/file-upload'
            component={FileUpload}
          />
          <PrivateRoute
            exact
            path='/employee-data/view-errors'
            component={ViewErrors}
          />
          <PrivateRoute
            exact
            path='/employee-data/view-result'
            component={ViewResult}
          />
          <PrivateRoute
            exact
            path='/activity-log'
            component={ActivityLog}
          />
          <PrivateRoute
            exact
            path='/doctor-consultation'
            component={MainLayout}
            child={DoctorConsultationPage}
          />
          <PrivateRoute
            exact
            path='/pharmacy'
            component={MainLayout}
            child={PharmacyPage}
          />
          <PrivateRoute
            exact
            path='/health-coach-programs'
            component={MainLayout}
            child={HealthCoachPage}
          />
          <PrivateRoute
            exact
            path='/gym-and-fitness'
            component={MainLayout}
            child={GymAndFitnessPage}
          />
          <PrivateRoute
            exact
            path='/invoices'
            component={MainLayout}
            child={Pages.CompanyInvoicesPage}
          />
          <PrivateRoute 
            exact
            path='/provider-network'
            component={MainLayout}
            child={Pages.ProviderNetwork}
          />
          <PrivateRoute
            exact
            path='/invoices/:invoiceNo/participation-list'
            component={Pages.MISInvoices}
          />
          <PrivateRoute 
            exact
            path='/health-checks/network'
            component={ViewPage}
          />
          <PrivateRoute 
            exact
            path='/dental-checks/network'
            component={ViewPage}
          />
          <PrivateRoute 
            exact
            path='/vision-checks/network'
            component={ViewPage}
          />
          <PrivateRoute
            exact
            path='/mailer'
            component={MainLayout}
            child={MailLandingPage}
          />
          <PrivateRoute
            exact
            path='/mail-setup'
            component={MainLayout}
            child={MailSetup}
          />
          <PrivateRoute
            exact
            path='/mail-config'
            component={MailConfig}
            child={MailConfig}
          />
          <PrivateRoute
            exact
            path='/account-settings'
            component={MainLayout}
            child={Pages.AccountSettings}
          />
          <PrivateRoute
            exact
            path='/account-settings/mfa-method'
            component={MainLayout}
            child={Pages.SettingsMFAMethodPage}
          />
          <PrivateRoute
            exact
            path='/account-settings/mfa-qr'
            component={MainLayout}
            child={Pages.SettingsQRCodePage}
          />
          <PrivateRoute
            exact
            path='/account-settings/mfa-otp'
            component={MainLayout}
            child={Pages.SettingsOTPPage}
          />
          <PrivateRoute
            exact
            path='/account-settings/mfa-backup-code'
            component={MainLayout}
            child={Pages.SettingsBackupCodesPage}
          />
          <PrivateRoute
            exact
            path='/mis-pulse'
            component={MainLayout}
            child={misPage}
          />
           <PrivateRoute
            exact
            path='/mis-pulse/add'
            component={MainLayout}
            child={AddMisPulse}
          />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;
